import { createContext, useContext } from "react";
import { URL_CONTACT_US } from "~/utils/url/staticUrls";

export interface ConfiguratorPageCustomization {
  showRegistrationBanner: boolean;
  showPrice: boolean;
  showAvailability: boolean;

  forceShowCAD: boolean; // Allow using CAD without being logged in
  showSave: boolean; // Show save button
  embedded: boolean; // This is an embedded configuration
  showDownloadPDF: boolean;
  showRequestQuotation: boolean; // Show "request a quote" button from SCHAEFF-37836
  showContactSpecialistLink: boolean;
  specialistLinkURL: string;
}

export const ConfiguratorPageCustomizationContext = createContext<ConfiguratorPageCustomization>({
  showRegistrationBanner: true,
  showPrice: true,
  showAvailability: true,

  forceShowCAD: false,
  showSave: true,
  embedded: false,
  showDownloadPDF: true,
  showRequestQuotation: true, // TODO FALSE
  showContactSpecialistLink: true, // TODO
  specialistLinkURL: URL_CONTACT_US, // TODO
});

export const useConfiguratorPageCustomization = () => useContext(ConfiguratorPageCustomizationContext);
